import { PREFIXED_LOCALES, STORAGE_KEY } from "./config";

// First of fr/de/es in the device's language list, or null when English
// (or nothing we support) comes first. Compares primary subtags: "fr-CA" -> "fr".
export function preferredSupportedLocale(languages) {
  for (const language of languages) {
    const primary = language.toLowerCase().split("-")[0];

    if (primary === "en") {
      return null;
    }
    if (PREFIXED_LOCALES.includes(primary)) {
      return primary;
    }
  }

  return null;
}

export function getSavedLocale() {
  return localStorage.getItem(STORAGE_KEY);
}

export function saveLocale(locale) {
  localStorage.setItem(STORAGE_KEY, locale);
}
